import { getEnvironment } from '../../common/environment/index'
import { generatePdfFromHtml } from '../../utils/pdf/generatePdfFromHtml.js'

function routePath(
  match: string,
  before: string,
  path: string,
  after: string
): string {
  let result = match

  if (path.charAt(0) === '/') {
    const origin =
      getEnvironment() === 'localhost'
        ? 'https://www.qa.ameriprise.com'
        : window.location.origin

    result = before + origin + path + after
  }

  return result
}

function routePath2(
  match: string,
  before: string,
  path: string,
  after: string
): string {
  let result = match

  if (path.charAt(0) === '/') {
    const origin = 'https://www.ameriprise.com/'

    result = before + origin + path + after
  }

  return result
}

function routePaths(html: string): string {
  return html
    .replace(/(src=")([^"]+)(")/g, routePath)
    .replace(/(href=")([^"]+)(")/g, routePath)
    .replace(/(url\(")([^")]+)(")/g, routePath2)
    .replace(/(url\()([^)]+)(\))/g, routePath2)
}

export async function getDownloadHtml(body: string): Promise<string> {
  const html = `
    <html>
      <head>
        <meta charset="utf-8">
        <title>IRA Rollover Evaluator</title>
        <style>
        /* Override a few adel stylings which don't display as desired in pdf view */
        /* TODO:  Some of these will become redundant in a future ADEL release.  Delete if no longer needed */
        .u-adel-reset .Content ol, .u-adel-reset .Content ul { list-style-type: disc; }
        .adel-material-symbols { display:none ; } 
      }
        </style>
      </head>
      <body class="u-adel-reset amp-scope">
        <div class="Content u-posRelative">
          ${body}
        </div>
      </body>
    </html>
    `
  return routePaths(html)
}

export function toggleLoader(selector: string, show: boolean): void {
  const loader = document.querySelector(selector)
  if (!loader) return
  loader.classList.toggle('u-hidden', !show)
}

export default async function download(body: string): Promise<void> {
  const html = await getDownloadHtml(body)
  const filename = `IRA-ROLLOVER-EVALUATOR-${new Date().getTime()}.pdf`
  try {
    toggleLoader('#pdf-download-spinner', true)
    await generatePdfFromHtml(html, [20, 10, 20, 10], 550, filename)
  } catch {
    console.error('PDF generation failed')
  } finally {
    toggleLoader('#pdf-download-spinner', false)
  }
}

export async function emailForm(body: string): Promise<string> {
  const html = await getDownloadHtml(body)
  const escapeChars: Record<string, string> = {
    '‘': '&lsquo;',
    '’': '&rsquo;',
    '“': '&ldquo;',
    '”': '&rdquo;',
    '©': '&copy;',
    '®': '&reg;',
    '™': '&trade;',
    '¼': '&frac14;',
    '½': '&frac12;',
    '¾': '&frac34;',
    '¢': '&cent;',
    '£': '&pound;',
    '¥': '&yen;',
    '€': '&euro;'
  }
  let regexString = '['
  for (const key in escapeChars) {
    regexString += key
  }
  regexString += ']'
  const regex = new RegExp(regexString, 'g')
  return html.replace(regex, function (m: string): string {
    return escapeChars[m] ?? m
  })
}
